import {InjectionToken} from "@angular/core";
import {ApiRoutesModel} from "../models/apiRoutesModel";

export const BASE_URL = new InjectionToken<string>('base_url');
export const API_ROUTES = new InjectionToken<ApiRoutesModel>('api_routes');
